/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import Router from './routes/routes'
import GlobalStyles from './styles/GlobalStyles'
import { ToastContainer } from 'react-toastify'
//@ts-ignore
import 'react-toastify/dist/ReactToastify.css'
import { Analytics } from '@vercel/analytics/react'

import { FilterProvider } from './context/FiltersContext/TeamFilter'
import { FilterProviderClient } from './context/FiltersContext/ClientFilter'
import { FilterProviderProduto } from './context/FiltersContext/ProdutosFilter'
import { MonthFilterProvider } from './context/FiltersContext/MonthFilter'
import LoadingScreen from './components/SplashScreen'
import { GeralFilterProvider } from './context/FiltersContext/PeriodoFilter'
import { GeralClienteFilterProvider } from './context/FiltersContext/ClientsPeriodoFiltro'
import { CustomThemeProvider } from './context/Theme/ThemeContextData'
import { AuthProvider } from './context/AuthContext'
import { DashMain } from './view/Dashboard/styles'

import { EstoqueFilterProvider } from './context/FiltersContext/EstoqueFilter'
import CookieConsent from './components/CookieConsent'
import GisaAssistant from './components/GisaAssistant'

// Supressão global de logs e proteção de dados no console
if (process.env.NODE_ENV === 'production' || !(window as any).__DEV__) {
  console.log = () => {}
  console.debug = () => {}
  console.info = () => {}
  console.warn = () => {}
}

const AppRoot = () => {
  const [loading, setLoading] = useState(true)
  // Detecção robusta do ambiente Electron

  useEffect(() => {
    // Reduzido o tempo de loading para ser mais ágil
    const timer = setTimeout(() => {
      setLoading(false)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <DashMain>
      <Router />
      <GisaAssistant />
      <CookieConsent />
      <GlobalStyles />
      <Analytics />
      <ToastContainer style={{ zIndex: 4000000 }} autoClose={1500} className='toast-container' />
    </DashMain>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <CustomThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <MonthFilterProvider>
          <EstoqueFilterProvider>
            <FilterProvider>
              <FilterProviderClient>
                <FilterProviderProduto>
                  <GeralFilterProvider>
                    <GeralClienteFilterProvider>
                      <AppRoot />
                    </GeralClienteFilterProvider>
                  </GeralFilterProvider>
                </FilterProviderProduto>
              </FilterProviderClient>
            </FilterProvider>
          </EstoqueFilterProvider>
        </MonthFilterProvider>
      </BrowserRouter>
    </AuthProvider>
  </CustomThemeProvider>,
)
